import { useExtensionUpsellInChat } from "@mirage/mosaics/ComposeAssistant/onboarding/useExtensionUpsellInChat";
import { ExtensionUpsellBanner } from "./ExtensionUpsellBanner";
import styles from "./ExtensionUpsellBannerContainer.module.css";

export const ExtensionUpsellBannerContainer = () => {
  const { extensionInfo, onDismiss } = useExtensionUpsellInChat();

  if (!extensionInfo) {
    return null;
  }

  return (
    <div className={styles.extensionUpsellBannerContainer}>
      <ExtensionUpsellBanner
        extensionInfo={extensionInfo}
        onDismiss={onDismiss}
      />
    </div>
  );
};
